module.exports = __webpack_public_path__ + "static/img/4.7a840ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/4.png
// module id = FvGc
// module chunks = 0